import type { ScanUploadState } from "@/views/case-settings/upload/shared/ScanUploadState";
import type { DicomPatientIdentityCheck } from "@/lib/dicom/validatePatientIdentities";
import type { PatientComparison } from "@/lib/dicom/PatientComparisonUtil";

export enum UploadEvent {
    Start = 'start',
    Completed = 'completed',
    Next = 'next',
}

export function isUploadEvent(value: any): value is UploadEvent {
    return [ 'start', 'completed', 'next' ].includes(value);
}

export interface UploadWorkerConfig {
    workerUrl: string;
    caseId: number;
    studyId: string;
    workerMessage: any;
    fileCount: number;
    onComplete: () => void | Promise<void>;
}

export interface UploadState {
    state: ScanUploadState;
    hasUploaded: boolean;
    error: string;
    progress: {
        current: number;
        total: number | null;
        error: null | string;
        worker: Worker | null;
    };
    patientIdentityCheck: DicomPatientIdentityCheck | null;
    patientComparison: PatientComparison | null;
}
